import { type Mesh, Matrix3 } from '@seddi/three';

import type { StyleLogoRegion } from '../api/styleAggregator';
import type { FrameBounds } from './frameLookAt';
import { computeFrameBounds as computeGeometryFrameBounds } from './frameBufferGeometryRegion';
import { finishFrameBounds } from './frameStyleRegion';

const normalMatrix = new Matrix3();

export const computeFrameBounds = (region: StyleLogoRegion, mesh: Mesh): FrameBounds => {
  const bounds = computeGeometryFrameBounds(region, mesh.geometry);
  bounds.sphere.applyMatrix4(mesh.matrixWorld);
  normalMatrix.getNormalMatrix(mesh.matrixWorld);
  bounds.normal.applyNormalMatrix(normalMatrix);
  finishFrameBounds(region, bounds);
  return bounds;
};
